import { useEffect, useRef } from "react";
import "../components/Landing/landing.css";
import { track } from "../components/Landing/landingTrack";
import { landingSwitches } from "../components/Landing/landingSwitches";
import LandingNewsStrip from "../components/Landing/LandingNewsStrip";
import LandingHeader from "../components/Landing/LandingHeader";
import LandingHero from "../components/Landing/LandingHero";
import LandingBeforePay from "../components/Landing/LandingBeforePay";
import LandingVideo from "../components/Landing/LandingVideo";
import LandingSample from "../components/Landing/LandingSample";
import LandingHowItWorks from "../components/Landing/LandingHowItWorks";
import LandingContests from "../components/Landing/LandingContests";
import LandingPlans from "../components/Landing/LandingPlans";
import LandingTrust from "../components/Landing/LandingTrust";
import LandingTestimonials from "../components/Landing/LandingTestimonials";
import LandingFooter from "../components/Landing/LandingFooter";

const DOCUMENT_TITLE = "Acertei Questões";

export default function LandingView() {
  const landingViewed = useRef(false);

  useEffect(() => {
    document.title = DOCUMENT_TITLE;
  }, []);

  useEffect(() => {
    if (landingViewed.current) return;
    landingViewed.current = true;
    track("landing_viewed");
  }, []);

  return (
    <div className="landing-v3">
      {landingSwitches.newsStrip ? <LandingNewsStrip /> : null}
      <LandingHeader />
      <LandingHero />
      <LandingBeforePay />
      <LandingVideo />
      <LandingSample />
      <LandingHowItWorks />
      <LandingContests />
      <LandingPlans />
      <LandingTrust />
      {landingSwitches.testimonials ? <LandingTestimonials /> : null}
      <LandingFooter />
    </div>
  );
}
